import type { ICarUsedAdView } from "@finn-no/adview-provider-frontend-types";
import { Trans, useLingui } from "@lingui/react";
import { Fragment } from "react/jsx-runtime";

export const SelfDeclaration = ({ ad }: { ad: ICarUsedAdView }) => {
  const { i18n } = useLingui();

  const { damages, repairs, engine, price } = ad;
  const sections = {
    damages: {
      condition: damages?.has_known_damages,
      message: i18n.t({
        id: "itemPageLayout.selfDeclaration.damages.title",
        message: "Does the car have known damages?",
      }),
      details: damages?.damages_details,
    },
    repairs: {
      condition: repairs?.has_undergone_repairs,
      message: i18n.t({ id: "itemPageLayout.selfDeclaration.repairs.title", message: "Have major repairs been made?" }),
      details: repairs?.repairs_details,
    },
    tuned: {
      condition: engine?.tuned,
      message: i18n.t({
        id: "itemPageLayout.selfDeclaration.tuned.title",
        message: "Is or has the engine been tuned?",
      }),
      details: engine?.adjustments,
    },
    liabilities: {
      condition: price?.has_liabilities,
      message: i18n.t({
        id: "itemPageLayout.selfDeclaration.liabilities.title",
        message: "Does the car have encumbrances/debt?",
      }),
      details: price?.liabilities_details,
    },
  };
  const show = Object.values(sections).some((section) => section.condition !== undefined);

  if (!show) return null;

  return (
    <section className="mt-40 pt-40 border-t">
      <h2 className="t3 mb-0">
        <Trans id="itemPageLayout.selfDeclaration.title" message="Seller's knowledge of the car" />
      </h2>
      {Object.entries(sections).map(([key, { condition, message, details }]) => (
        <Fragment key={key}>
          {condition === undefined ? null : (
            <>
              <p className="font-bold mt-16 mb-0">{message}</p>
              <Condition condition={condition} details={details} />
            </>
          )}
        </Fragment>
      ))}
    </section>
  );
};

const Condition = ({ condition, details }: { condition: boolean; details: string | undefined }) => {
  return (
    <p className="mb-0 mt-16">
      {condition ? (
        <Trans id="itemPageLayout.selfDeclaration.condition.yes" message="Yes. " />
      ) : (
        <Trans id="itemPageLayout.selfDeclaration.condition.no" message="No" />
      )}
      {details ?? null}
    </p>
  );
};
